<mat-card class="top" data-testId="chatContainerId">
    <mat-card-header>
        <mat-card-title>
            {{data.question.shortLabel | translateLabel:data.activeLang}} ({{data.question.key}})
        </mat-card-title>
    </mat-card-header>

  <iframe width="100%" height="640px" [src]="iframeUrl | safeUrl"></iframe>

</mat-card>
